import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import Select from "react-select";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import FileDownload from "js-file-download";
const { formatarReal } = require("../../utils");

class VeiculoManutencao extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadVeiculos = this.loadVeiculos.bind(this);
    this.gerarRelatorio = this.gerarRelatorio.bind(this);

    this.state = {
      checklistProblemas: [],
      veiculoSelecionado: null,
      veiculos: [],
      statusSelecionado: "todos",
    };
  }

  async componentDidMount() {
    await this.load();
    await this.loadVeiculos();
  }

  async load() {
    let veiculo = this.state.veiculoSelecionado;

    if (veiculo !== null) {
      veiculo = veiculo._id;
    } else {
      veiculo = "";
    }

    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/manutencao-veiculos?veiculo=${veiculo}&status=${
          this.state.statusSelecionado
        }`,
        this.props.parameters()
      )
      .then((response) => {
        let checklistProblemas = response.data.checklistProblemas;

        this.setState({ checklistProblemas });
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async loadVeiculos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/veiculos`,
        this.props.parameters()
      )
      .then((response) => {
        let veiculos = response.data.veiculos;
        veiculos.map((veic) => {
          veic.label = veic.desc;
          veic.value = veic._id;
          return veic;
        });

        this.setState({ veiculos });
      })
      .catch((error) => {
        // this.setState({ despesaDeletar: null, modal: false }, () => {
        //   this.notificar("warning", error.response.data.erro);
        // });
      });
  }

  async gerarRelatorio() {
    ////console.clear()
    console.log(JSON.stringify(this.state))


    let listaFormatada = [];
    let lista = this.state.checklistProblemas;

    for (let item of lista) {

      listaFormatada.push({
        placa: item.veiculo.placa,
        veiculo: item.veiculo.desc,
        motorista: item.motorista.desc,
        dataHora: moment(item.dtGravacao).format('DD/MM/YYYY HH:mm'),
        tipo: item.tipo.slice(0, 1).toUpperCase() + item.tipo.slice(1),
        problemas: item.problemas.length,
        status: item.status.slice(0, 1).toUpperCase() + item.status.slice(1)
      });
    }

    // let dataInicial = this.state.dataInicial;
    // let dataFinal = this.state.dataFinal;

    let nomeArquivo = `manutencoes-veiculos`;
    // let nomeArquivo = `manutencoes-veiculos-${moment(dataInicial)
    //   .startOf("day")
    //   .format("YYYY-MM-DD")}-${moment(dataFinal)
    //   .startOf("day")
    //   .format("YYYY-MM-DD")}.xlsx`;

    let veiculo = "Todos";
    let status = this.state.statusSelecionado;

    if(status === 'todos'){
      status = 'Todos';
    } else if(status === 'pendente'){
      status = 'Pendente';
    } else if(status === 'finalizado'){
      status = 'Finalizado';
    }

    if(this.state.veiculoSelecionado !== null){
      veiculo = this.state.veiculoSelecionado.desc;
    }

    let parametros = {
      manutencoes: listaFormatada,
      veiculo,
      status
    };

    await axios
      .post(`${this.props.getBaseUrlImpressao()}/manutencoes-pdf`, { parametros })
      .then(async (response) => {
        // FileDownload(response.data, nomeArquivo);
        localStorage.setItem('html', response.data.html)
        localStorage.setItem('tituloPagina', nomeArquivo)
      window.open("/impressao", "_blank");
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
  }
  async gerarRelatorio2() {
    ////console.clear()
    console.log(JSON.stringify(this.state))


    let listaFormatada = [];
    let lista = this.state.checklistProblemas;

    for (let item of lista) {

      listaFormatada.push({
        PLACA: item.veiculo.placa,
        VEICULO: item.veiculo.desc,
        MOTORISTA: item.motorista.desc,
        DATA: moment(item.dtGravacao).format('DD/MM/YYYY'),
        HORA: moment(item.dtGravacao).format('HH:mm'),
        TIPO: item.tipo.slice(0, 1).toUpperCase() + item.tipo.slice(1),
        PROBLEMAS: item.problemas.length,
        STATUS: item.status.slice(0, 1).toUpperCase() + item.status.slice(1)
      });
    }

    // let dataInicial = this.state.dataInicial;
    // let dataFinal = this.state.dataFinal;

    let nomeArquivo = `manutencoes-veiculos.xlsx`;
    // let nomeArquivo = `manutencoes-veiculos-${moment(dataInicial)
    //   .startOf("day")
    //   .format("YYYY-MM-DD")}-${moment(dataFinal)
    //   .startOf("day")
    //   .format("YYYY-MM-DD")}.xlsx`;

    let params = {};
    params.responseType = "blob";

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/relatorios`,
        { lista: listaFormatada },
        params
      )
      .then(async (response) => {
        FileDownload(response.data, nomeArquivo);
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
      // import FileDownload from "js-file-download";
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container-scroller font-app">
          <NavBar title="Manutenção de Veículos" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"manutencaoVeiculos"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription title="Veículos" description="" /> */}





                <div
                  className="row"
                  style={{ marginBottom: "0.8rem", alignItems: "center" }}
                >
                  <div className="col-md-12 stretch-card">
                    {true && (
                      <div className="card">
                        <div
                          className="card-body5"
                          style={{ position: "relative" }}
                        >
                          <React.Fragment>
                            {/* <div
                              style={{
                                position: "absolute",
                                top: "11px",
                                right: "11px",
                              }}
                            >
                              <button
                                className="btn btn-success btn-app-verde-sm"
                                onClick={() => {
                                  this.props.history.push("/fornecedor-novo");
                                }}
                              >
                               CADASTRAR
                              </button>
                            </div> */}
                            <div className="row">
                              <div className="col-md-2 col-6 pd-veiculo2">
                                <div className="form-group-chegoo font-size-14">
                                  <label>Veículo</label>
                                  <Select
                                    value={this.state.veiculoSelecionado}
                                    onChange={(value) => {
                                      this.setState({
                                        veiculoSelecionado: value,
                                      });
                                    }}
                                    options={this.state.veiculos}
                                    placeholder="Selecione"
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        fontSize: "14px",
                                        height: "35px",
                                        minHeight: "35px"
                                      }),
                                      menu: (baseStyles, state) => ({
                                        ...baseStyles,
                                        fontSize: "14px",
                                        marginTop: "30px"
                                      }),
                                    }}
                                    className="custom-select2" // Adicione uma classe personalizada
                                  />
                                </div>
                              </div>

                           
                              <div className="col-md-2 col-6 pd-veiculo">
                                <div className="form-group-chegoo form-group-chegoo2 font-size-14">
                                  <label>Status</label>
                                  <select
                                    className="form-control font-size-14 form-control-chegoo"
                                    value={this.state.statusSelecionado}
                                    onChange={(e) => {
                                      this.setState({
                                        statusSelecionado: e.target.value,
                                      });
                                    }}
                                  >
                                    <option value="todos">Todos</option>
                                    <option value="pendente">Pendente</option>
                                    <option value="finalizado">
                                      Finalizado
                                    </option>
                                  </select>
                                </div>
                              </div>
                              


                              <div
                                className="col-md-2 pd-veiculo"
                                style={{ display: "flex", marginTop: "15px" }}
                              >
                                <div
                                  className="form-group-chegoo2"
                                  style={{ float: "left" }}
                                >
                                  <label></label>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    style={{
                                      padding: "0.275rem 0.55rem",
                                      margin: "7px 5px 0px",
                                    }}
                                    onClick={() => this.load()}
                                    id={`tooltip-filtro-atendimentos`}
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                      style={{ fontSize: "px" }}
                                    ></i>
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`tooltip-filtro-atendimentos`}
                                  >
                                    Filtrar
                                  </UncontrolledTooltip>
                                </div>
                                <div className="form-group-chegoo2">
                                  <label></label>
                                  <button
                                    className="btn btn-warning btn-sm"
                                    style={{
                                      padding: "0.275rem 0.55rem",
                                      margin: "7px 5px 0px",
                                      color: "#FFF"
                                    }}
                                    onClick={() => this.limparFiltros()}
                                    id={`tooltip-limpar-filtro-atendimentos`}
                                  >
                                    <i
                                      className="fa fa-eraser"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`tooltip-limpar-filtro-atendimentos`}
                                  >
                                    Limpar filtro
                                  </UncontrolledTooltip>
                                </div>
                                <div className="form-group-chegoo2">
                                  <label></label>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    style={{
                                      padding: "0.275rem 0.55rem",
                                      margin: "7px 5px 0px",
                                    }}
                                    onClick={() => this.gerarRelatorio()}
                                    id={`tooltip-limpar-filtro-atendimentos`}
                                  >
                                    <i
                                      className="fa fa-file-pdf-o"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`tooltip-limpar-filtro-atendimentos`}
                                  >
                                    Gerar relatório
                                  </UncontrolledTooltip>
                                </div>
                              </div>

                             


                              {/* <div
                                className="col-md-2"
                                style={{
                                  marginTop: "15px",
                                  marginTop: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                <button
                                  className="btn btn-success btn-app-verde-sm"
                                  onClick={() => {
                                    this.props.history.push("/fornecedor-novo");
                                  }}
                                >
                                  CADASTRAR
                                </button>
                              </div> */}
                            </div>
                          </React.Fragment>
                        </div>
                      </div>
                    )}
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-12 stretch-card">
                    {this.state.checklistProblemas.length > -1 && (
                      <div className="card">
                        <div className="card-body2">
                          <React.Fragment>
                        
                            <div className="table-responsive">
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead className="thead-dark">
                                  <tr>
                                    <th># Placa</th>
                                    <th>Veículo</th>
                                    <th>Motorista</th>
                                    <th className="text-center">Data</th>
                                    <th>Tipo</th>
                                    <th>Hora</th>
                                    <th className="text-center">Problemas</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.checklistProblemas.map(
                                    (item, key) => (
                                      <tr key={key} style={{backgroundColor: item.status === 'pendente' ? '#fffabf' : 'inherit'}}>
                                        <td
                                          style={{
                                            fontWeight: "bold",
                                            color: "inherit",
                                          }}
                                        >
                                          {item.veiculo.placa}
                                        </td>
                                        <td>
                                          {item.veiculo.desc} -{" "}
                                          {/* {veiculo.anoFabricacao} */}
                                        </td>
                                        <td>{item.motorista.desc}</td>
                                        <td className="text-center">
                                          {moment(item.dtGravacao).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </td>
                                        <td>
                                          {item.tipo === "saida"
                                            ? "Saída"
                                            : "Chegada"}
                                        </td>
                                        <td>
                                          {" "}
                                          {moment(item.dtGravacao).format(
                                            "HH:mm"
                                          )}
                                        </td>
                                        <td className="text-center">
                                          {item.problemas.length}
                                        </td>
                                        <td className="text-center">
                                          {item.status === "pendente"
                                            ? "Pendente"
                                            : "Finalizado"}
                                        </td>

                                        <td
                                          className="text-center"
                                          style={{ fontSize: "18px" }}
                                        >
                                          <div
                                            style={{
                                              margin: "2px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i
                                              className="fa fa-search"
                                              onClick={() => {
                                                this.props.history.push(
                                                  `/manutencao-veiculos-detalhe?id=${item._id}`
                                                );
                                              }}
                                            ></i>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                        
                          </React.Fragment>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Deletar veículo</ModalHeader>
          <ModalBody>Tem certeza que deseja deletar este veículo?</ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggle}
            >
              Não
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleClickConfirmaDeletar}
            >
              Sim
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default VeiculoManutencao;
